import $ from 'jquery';

class Animate {
	constructor(el, settings) {
		this.el = el;
		this.animateClass = settings.animateClassName;
		this.offsetPos = settings.offset;
		this.init();
	}

	init() {
		const sections = document.querySelectorAll(this.el);

		let config = {
			rootMargin: '0px',
			threshold: this.offsetPos,
		};

		let observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					$(entry.target).addClass(this.animateClass);
				}
			});
		}, config);

		sections.forEach((section) => {
			observer.observe(section);
		});
	}
}

export default Animate;
